export default "/_next/static/data/personalization-is-no-longer-an-option-lottie.json-0eda828fc794a8f64a6c91fb5b2da469.json";